<template>
  <div class="list-container">
    <div v-show="!dialogFormVisible && !materDeliveryVisible">
      <div class="filter-container">
        <template v-if="!isFilterCollapse">
          <div class="filter-box">
            <span class="label">业务编号</span>
            <el-input
              v-model="listQuery.no"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">名称</span>
            <el-input
              v-model="listQuery.name"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">品牌</span>
            <el-input
              v-model="listQuery.brand"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">型号</span>
            <el-input
              v-model="listQuery.model"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <!-- <div class="filter-box">
            <span class="label">序列号</span>
            <el-input
              v-model="listQuery.serial"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div> -->
          <div class="filter-box">
            <span class="label">业务员</span>
            <el-select :filterable="true" v-model="listQuery.salesManId" class="filter-item" placeholder="" clearable :size="t('table.btnSize')" @change="handleFilter">
              <el-option
                v-for="item in salesManOption"
                :key="item.id"
                :label="item.mark"
                :value="item.id"
              />
            </el-select>
          </div>
          <div class="filter-box" v-if="isExistEngineerFilter">
            <span class="label">工程师</span>
            <el-select :filterable="true" v-model="listQuery.engineerId" class="filter-item" placeholder="" :size="t('table.btnSize')" clearable @change="handleFilter">
              <el-option
                v-for="item in engineerOption"
                :key="item.id"
                :label="item.mark"
                :value="item.id"
              />
            </el-select>
          </div>
          <div class="filter-box">
            <span class="label">开始日期</span>
            <el-date-picker
              v-model="listQuery.startTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
          <div class="filter-box">
            <span class="label">结束日期</span>
            <el-date-picker
              v-model="listQuery.endTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
          <div class="filter-box">
            <el-radio-group v-model="listQuery.completed" @change="handleFilter">
              <el-radio :value="false" :label="false">未完成</el-radio>
              <el-radio :value="true" :label="true">完成</el-radio>
              <el-radio :value="null" :label="null">全部</el-radio>
            </el-radio-group>
          </div>
        </template>
        <div class="filter-box">
          <el-button
            v-waves
            class="filter-item "
            type="primary"
            :size="t('table.btnSize')"
            @click="handleFilter"
          >
            {{ t("table.search") }}
          </el-button>
          <el-button
            v-waves
            class="filter-item"
            :size="t('table.btnSize')"
            @click="handleReset"
          >
            {{ t("table.reset") }}
          </el-button>
          <el-button
            v-waves
            class="filter-item"
            :size="t('table.btnSize')"
            @click="isFilterCollapse = !isFilterCollapse"
          >
            {{ isFilterCollapse ? '展开' : '收起' }}
          </el-button>
          <span class="svg-icon cursor mr-10 ml-10" @click="handleCommand('refresh')">
              <i class="icon-tubiao-27 iconfont"/>
            </span>
          <span class="svg-icon cursor" @click="handleCommand('column')">
              <i class="icon-tubiao-28 iconfont"/>
            </span>
        </div>

      </div>
      <div class="split-table-layout">
        <!-- 主表区域 -->
        <div
          class="split-pane-top vue-grid-item"
          :style="{ height: isSubMenuCollapse ? '100%' : `${topHeight}px` }"
        >
          <TableList
              :ref="rf => { if (rf) tableDataRef[0] = rf }"
              v-loading="listLoading"
              :dataList="list"
              :total="total"
              :columnAllData="columnAllData"
              :page="listQuery.page"
              :size="listQuery.size"
              :tableName="TableName"
              :handleDefaultWidth="130"
              :permissionName="permissionName"
              @command-change="handleCommand"
              :can-refresh="false"
              :can-change-column="false"
              :highlightCurrentRow="true"
              :isShowPagination="false"
              :newHpx="newHpx"
              style="height:100%;overflow:hidden;"
            >
              <template v-slot:no="scope">
                <template v-if="scope.row.changeStatus !== '申请取消'">
                  <svg
                    class="icon"
                    aria-hidden="true"
                    font-size="20px"
                    v-if="scope.row.urgentIcon"
                  >
                    <use :xlink:href="'#' + scope.row.urgentIcon"/>
                  </svg>
                  <span>{{ scope.row.no }} </span>
                </template>
                <span v-else class="statusStyle yellowStatusStyle" >
                  <template v-if="['申请取消'].includes(scope.row.changeStatus)">
                    <i class="iconfont icon-tubiao-40" ></i>
                    <span class="status" >{{scope.row.changeStatus}} </span>
                  </template>
                  <span>{{scope.row.no}}</span>
                </span>
              </template>
              <template v-slot:completed="scope">
                <span>{{ scope.row.completed ? '已完成' : '未完成' }} </span>
              </template>
              <template v-slot:repairTimes="scope">
                <span>{{ scope.row.repairTimes || 0 }} </span>
              </template>
              <template v-slot:operation-action="scope">
                <el-link
                  v-if="scope.row.changeStatus !== '申请取消'"
                  v-permission="{ pkey: `${permissionName}_ACTION` }"
                  href="javascript:void(0);"
                  class="mr-10"
                  type="primary"
                  @click="handleCommand('action', scope.row)"
                >
                  {{scope.row.repairTypeName}}
                </el-link>
                <el-link
                  v-if="!scope.row.completed"
                  v-permission="{ pkey: `${permissionName}_ACTION` }"
                  href="javascript:void(0);"
                  class="mr-10"
                  type="primary"
                  @click="handleCommand('materDelivery', scope.row)"
                >
                  材料出库
                </el-link>
              </template>
            </TableList>
        </div>

        <!-- 水平交互分割线 -->
        <TableSplitter
          v-if="!isSubMenuCollapse && tabList.length"
          @drag-start="handleSplitterDragStart"
          @drag-move="handleSplitterDragMove"
          @drag-end="handleSplitterDragEnd"
        />

        <!-- 子表区域 -->
        <div
          v-show="!isSubMenuCollapse && tabList.length"
          class="split-pane-bottom"
          :style="{ height: `${bottomHeight}px` }"
        >
          <div class="clearfix tab-title btn-container mt-10">
                <ul class="tab-title_left fl">
                  <li
                    v-for="item in tabList"
                    :key="item.id"
                    :class="{ active: activeTab === item.id }"
                    @click="handleTabClick(item)">{{ item.name }}
                  </li>
                </ul>
              </div>
              <template v-if="tabList.length">
                <DeliverTable v-if="activeTab === 1" ref="DeliverTable" :id="activeId"/>
              </template>
        </div>
      </div>
    </div>
    <FormComponent
      v-if="dialogFormVisible"
      :id="activeId"
      :detail="activeDetail"
      :dialogFormVisible="dialogFormVisible"
      :api="'repair'"
      :handleResolveTempData="handleResolveTempData"
      @update:visibel="() => dialogFormVisible = false"
      @submit="handleSubmit(formData)"
    />
    <FormDeliverComponent
      v-if="materDeliveryVisible"
      :id="activeId"
      type="BUSINESS"
      :detail="activeDetail"
      :api="'purchase'"
      :handleResolveTempData="handleResolveTempData"
      @update:visibel="() => materDeliveryVisible = false"
      @submit="handleSubmit(formData)"
    />
     <el-button
      type="primary"
      circle
      @click="handleSubMenuCollapse"
      class="subMenuCollapseBtn"
      v-if="!dialogFormVisible && !materDeliveryVisible && tabList.length"> {{ isSubMenuCollapse ? '展开' : '收起' }}
    </el-button>
  </div>
</template>

<script lang='ts'>
import TableSplitter from '@/components/common/TableSplitter.vue'
import { useTableSplitter } from '@/composables/useTableSplitter'
import { defineComponent, reactive, toRefs, onMounted, ref, watch } from 'vue'
import { ElMessage } from 'element-plus'
import { getPageList, getDetailById } from '@/apis/Dictionary'
import { getPageList as getUrlList } from '@/apis/Form'
import { UsersModel } from '@/model/userModel'
import { ArrayRowsItem } from '@/model/Index'
import FormComponent from './Form.vue'
import FormDeliverComponent from './FormDeliver.vue'
import TableList from '@/components/common/TableList.vue'
import { TableName, permissionName } from '@/utils/enum'
import { TableField } from './FieldTable'
import { defaultDate, pageVo } from '@/utils/index'
import { useI18n } from 'vue-i18n'
import mixin from '@/mixins/index'
import DeliverTable from '@/views/business/businessList/DeliverTable/Index.vue'

export default defineComponent({
  name: 'Repair',
  components: {
    TableSplitter,
    FormComponent,
    TableList,
    FormDeliverComponent,
    DeliverTable
  },
  setup() {
    const { t } = useI18n()
    const tableDataRef = ref([])

    const dataMap = reactive({
      TableName: TableName.TABLE_REPAIR,
      permissionName: permissionName.REPAIR,
      columnAllData: TableField,

      activeId: 0,
      activeDetail: undefined,
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        no: undefined,
        name: undefined,
        brand: undefined,
        model: undefined,
        serial: undefined,
        salesManId: undefined,
        completed: false,
        outsourceCompanyName: undefined,
        startTime: '',
        endTime: '',
        ...pageVo
      },
      isFilterCollapse: false,
      dialogFormVisible: false,
      salesManOption: [],
      engineerOption: [],
      isExistEngineerFilter: false,
      materDeliveryVisible: false,
      completedOption: [
        {
          mark: '未完成',
          id: false
        }, {
          mark: '完成',
          id: true
        }, {
          mark: '全部',
          id: null
        }
      ],
      tabList: [
        { name: '出库成本', id: 1 }
      ],
      activeTab: 1,
      newHpx: 0,

      handleCommand(command: string, val?: any) {
        switch (command) {
          case 'action':// 维修
            dataMap.handleRepair(val)
            break
          case 'refresh':
            dataMap.handleFilter()
            break
          case 'column':
            (tableDataRef.value[0] as any).setColumnVisible = true
            break
          case 'current-change':
            dataMap.handleCurrentChange(val)
            break
          case 'size-change':
            dataMap.handleSizeChange(val)
            break
          case 'materDelivery':
            dataMap.handleMaterDeliver(val)
            break
        }
      },
      getList() {
        dataMap.listLoading = true
        getPageList('repair', dataMap.listQuery).then((res: any) => {
          dataMap.list = res.data || []
          dataMap.total = res.total
          dataMap.listLoading = false
          dataMap.activeId = dataMap.list.length ? dataMap.list[0].id : 0
        }).catch(() => {
          dataMap.listLoading = false
        })
      },
      handleReset() {
        dataMap.listQuery = {
          no: undefined,
          name: undefined,
          brand: undefined,
          model: undefined,
          serial: undefined,
          salesManId: undefined,
          completed: false,
          outsourceCompanyName: undefined,
          startTime: defaultDate[0],
          endTime: defaultDate[1],
          ...pageVo
        }
        dataMap.handleFilter()
      },
      handleFilter() {
        const { startTime, endTime } = dataMap.listQuery
        const tempsStart = startTime ? new Date(startTime).getTime() : 0
        const tempdEnd = endTime ? new Date(endTime).getTime() : 0
        if (!tempsStart) {
          return ElMessage.error({
            message: '请选择开始时间',
            duration: 1000
          })
        } else if (!tempdEnd) {
          return ElMessage.error({
            message: '请选择结束时间',
            duration: 1000
          })
        } else if (tempsStart > tempdEnd) {
          return ElMessage.error({
            message: '开始时间必须小于结束时间',
            duration: 1000
          })
        }

        dataMap.getList()
      },
      async handleRepair(row: any) {
        dataMap.activeId = row.id
        dataMap.activeDetail = await getDetailById('repair', dataMap.activeId)
        dataMap.dialogFormVisible = true
      },
      async handleMaterDeliver(row: any) {
        dataMap.activeId = row.id
        // dataMap.activeDetail = await getDetailById('repair', dataMap.activeId)
        dataMap.activeDetail = row
        dataMap.materDeliveryVisible = true
      },
      handleSubmit() {
        dataMap.getList()
      },
      handleResolveTempData(tempModel: any) {
        const { model } = tempModel
        tempModel.model = model ? model.join(',') : ''
      },
      handleCurrentChange(page?: any) {
        dataMap.listQuery.page = page
        dataMap.getList()
      },
      handleSizeChange(size: any) {
        dataMap.listQuery.size = size
        dataMap.handleCurrentChange(1)
      },
      handleSalesManFocus() {
        getUrlList('user/dropdown/salesman').then((res: any) => {
          dataMap.salesManOption = res || []
        })
      },
      handleAccessUsers() {
        getUrlList('me/accessUsers').then((res: any) => {
          dataMap.isExistEngineerFilter = (res?.length !== 1)
        })
        getUrlList('user/dropdown/engineers?all=true').then((res: any) => {
          dataMap.engineerOption = res || []
        })
      },
      handleTabClick(item: any) {
        dataMap.activeTab = item.id
      },
      handleResizedEvent(i: any, newH: any, newW: any, newHPx: any) {
        dataMap.newHpx = newHPx
      }
    })
    const { mixinData } = mixin(dataMap)

    const splitter = useTableSplitter({
      storageKey: 'erp.split_ratio./repair/Index',
      defaultRatio: 0.38,
      minTopHeight: 140,
      minBottomHeight: 0,
      splitterHeight: 22,
      paginationHeight: 52,
      onResize: (topH) => {
        dataMap.newHpx = topH
      }
    })

    watch(() => mixinData.isFilterCollapse, () => {
      setTimeout(() => {
        splitter.applyLayout()
      }, 50)
    })
    onMounted(() => {
      mixinData.initHeight()
      dataMap.listQuery.startTime = defaultDate[0]
      dataMap.listQuery.endTime = defaultDate[1]
      dataMap.getList()
      dataMap.handleSalesManFocus()
      dataMap.handleAccessUsers()
    })
    return { t, ...toRefs(dataMap), ...toRefs(mixinData),
      ...splitter,
      handleSubMenuCollapse: splitter.toggleSubMenuCollapse, tableDataRef }
  }
})
</script>
<style lang="scss">

</style>
